import requester from "../requester";
import { GET_RELATE_INFO } from "../../constants";

const RelateInfo = {
  getRelateInfo: (listId) => requester.get(`${GET_RELATE_INFO}?page_type=${listId}`),
};

export default RelateInfo;
